export default __webpack_public_path__ + "static/media/ann.45870d10.svg";